<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
    </div>
    <div class="main">
      <el-form :model="pmmx" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div>
        <el-form-item label="项目名称" class="from-value">
          {{pmmx.project.projectname}}
        </el-form-item>
        </div>
        <div class="row ">
          <el-form-item label="名称" prop="pmmxname" verify>
            <el-input v-model="pmmx.pmmxname" :maxlength="50" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="pmmxunitid" verify>
            <el-select v-model="pmmx.pmmxunitid" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in unitList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" prop="pmmmake">
            <el-input v-model="pmmx.pmmmake" :maxlength="50" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="规格" prop="pmmspec">
            <el-input v-model="pmmx.pmmspec" :maxlength="50" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="型号" prop="pmmtype">
            <el-input v-model="pmmx.pmmtype" :maxlength="50" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="数量" prop="pmmxqty"  verify comdifyValdate>
            <el-input v-model="pmmx.pmmxqty" :maxlength="12" :disabled="disable" @blur="inputMoney($event,'pmmxqty')"></el-input>
          </el-form-item>

        </div>
        <div class="content">
          <el-form-item label="备注">
            <el-input style="width:518px" v-model="pmmx.pmmxremark" :maxlength="255" show-word-limit type="textarea" :disabled="disable"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'

  export default {
    name: "pmmxform",
    mixins: [common],
    data () {
      return {
        pmmx: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        unitList: []
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getUnitList()
    },
    watch: {},
    filters: {
      qfwVal (value) {
        return utils.comdify(value)
      }
    },
    components: {},
    computed: {},
    methods: {
      inputMoney (el, name) {
        let val = utils.delcommafy(el.target.value)
        var reg = /^[0-9]+.?[0-9]*$/
        if ((reg.test(val))) {
          this.pmmx[name] = utils.getInputValue(el)
        }
      },
      async init () {
        this.$refs['ruleForm'].clearValidate()
        this.pmmx = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        if(this.pmmx.pmmxqty) {
          this.pmmx.pmmxqty = utils.comdify(this.pmmx.pmmxqty)
        }
      },
      async getUnitList () {
        this.unitList = await request({
          method: 'get',
          url: '/basic/unit/getUnitList',
          params: {}
        })
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          this.pmmx.pmmxqty = utils.delcommafy(this.pmmx.pmmxqty)
          let data = await request({
            url: '/xmgl/project/savePmmx',
            method: "post",
            data: this.pmmx
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pmmxIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 200px;
    }
    .el-input-group__append, .el-input-group__prepend {
      padding: 0px 5px;
    }
  }
</style>
